class Dates {
  constructor() { }

  getDates(group) {
    var conversion = {
      "admission-april": ["opptak-april"],
      "admission-october": ["opptak-oktober"],
      "admission-april-october": [
        "opptak-to-arlig-april",
        "opptak-to-arlig-oktober"
      ],
      "admission-april-october-only-april": [
        "opptak-to-arlig-april"
      ],
      "admission-april-october-only-october": [
        "opptak-to-arlig-oktober"
      ]
    }
    var conversionStart = {
      "opptak-april": "01.08",
      "opptak-oktober": "01.01",
      "opptak-to-arlig-april": "01.08",
      "opptak-to-arlig-oktober": "01.01",
      "opptak-emhem": "01.08"
    }

    // ### Exceptions ###
    if(App.program.programCode === "MFM2-EMHEM") {
      var opptakDates = ["opptak-emhem"];
    } else if(App.program.dates === "admission-april-october" && group === "SFMASTER") {
      var opptakDates = conversion["admission-april-october-only-april"];
    } else if(App.program.dates === "admission-april-october" && App.program.programCode === "UVME-UTLED") {
      var opptakDates = conversion["admission-april-october-only-october"];
    } else {
      var opptakDates = conversion[App.program.dates];
    }

    for(var q in opptakDates) {
      var opptakDate = App.fellestekst[opptakDates[q]];

      var d = {
        "start": conversionStart[opptakDates[q]]
      };

      for(var id in opptakDate) {
        var name = id.split(/^(.*)\-([^\-]+)$/i)[1];
        var lookup = name + "-" + group;
        if (opptakDate[lookup].translations && opptakDate[lookup].translations["en"] && opptakDate[lookup].translations["en"].long && !d[name]) {
          d[name] = opptakDate[lookup].translations["en"].long.replace(/[^\d\.]/ig, "");
        }
      }
      App.date.push(d);
    }
    App.date.sort(function(a, b) {
      var startA = parseInt(a.start.replace(".", ""), 10);
      var startB = parseInt(b.start.replace(".", ""), 10);
      return startA - startB;
    });

    // ### Exceptions ###
    // Helseadministrasjon
    if(App.program.programCode === "MFME-HELAD") {
      App.date[0]["portal-opens"] = "01.02";
      App.date[0]["deadline"] = "01.03";
      App.date[0]["getting-results"] = "30.04";
      delete App.date[0]["documentation-deadline"];
      delete App.date[0]["early-answer-deadline"];
      delete App.date[0]["reprioritize"];
    }
  }

}

export default new Dates;
